import "./src/styles/reset.css";
import React from "react";
import { AppContextProvider } from "./src/context/AppContext";

export const wrapRootElement = ({ element }) => (
  <AppContextProvider>{element}</AppContextProvider>
);
